import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NotFound } from '@mgm/common/components';
import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import { Page } from '../components/Page';
import { getPreviousPath } from '../utils/helpers/routeTracker';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  const prevPath = getPreviousPath();
  const posthog = usePostHog();

  useEffect(() => {
    posthog.capture('404 Page Viewed', {
      previous_path: prevPath,
      current_url: window.location.pathname,
    });
  }, [prevPath]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleHome = () => {
    navigate('/');
  };

  return (
    <NotFound
      PageWrapper={Page}
      locale={{
        sorryPageNotFound: t('sorryPageNotFound'),
        sorryWeCouldntFindThePage: t('sorryWeCouldntFindThePage'),
        back: t('back'),
        goToLogin: t('goToLogin'),
      }}
      onBackClick={handleBack}
      onHomeClick={handleHome}
    />
  );
};

export default NotFoundPage;
